import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ArrowLeft } from 'lucide-react';
import { Navbar } from './navbar';
import { Sidebar } from './sidebar';
import { ChildrenType } from '../propTypes';

// `onBack` (optional) renders a back arrow before the title; `compact`
// (optional) uses the smaller drill-down title size. Both default off, so
// existing pages render exactly as before.
function NavigationLayout({
  children, title, subtitle, onBack, compact = false,
}) {
  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header">
          <div className="screen-header-container d-flex justify-content-between position-relative">
            <div className="d-flex align-items-center" style={{ gap: 8 }}>
              {onBack && (
                <button
                  type="button"
                  aria-label="Back"
                  onClick={onBack}
                  className="p-1 -ml-1 rounded text-ink-900 hover:bg-gray-100 transition flex-shrink-0"
                >
                  <ArrowLeft size={22} />
                </button>
              )}
              {compact ? (
                <h3
                  className="font-bold text-ink-900 leading-tight truncate text-xl lg:text-2xl"
                  style={{ margin: 0 }}
                  data-testid="title"
                >
                  {title}
                </h3>
              ) : (
                <h3
                  className="header-manage-member"
                  style={{ fontWeight: 700 }}
                  data-testid="title"
                >
                  {title}
                </h3>
              )}
            </div>
          </div>
          <p
            className="main-sub-text"
            data-testid="subtitle"
          >
            {subtitle}
          </p>
          {/* Insert components for the page here, to the right of the sidebar */}
          {children}
        </div>
      </div>
    </>
  );
}

export default NavigationLayout;

NavigationLayout.propTypes = {
  children: ChildrenType,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onBack: PropTypes.func,
  compact: PropTypes.bool,
};
